import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import type { SxProps } from "@mui/material/styles";

import { ErrorsState, FieldError } from "hooks/use-errors.hook";

interface ErrorListProps {
  errors: ErrorsState;
  fieldLabels?: Record<string, string>;
  showBackendErrors?: Record<string, boolean>;
  sx?: SxProps;
}

const getErrorMessage = (
  key: string,
  error: FieldError,
  fieldLabels: Record<string, string> | undefined = {},
  showBackendErrors: Record<string, boolean> | undefined = {}
) => {
  if (fieldLabels?.[key]) {
    return showBackendErrors[key]
      ? `${fieldLabels[key]}: ${error.message}`
      : `${fieldLabels[key]}`;
  }
  return error.message;
};

export default function ErrorList({
  errors,
  fieldLabels,
  showBackendErrors,
  sx = {}
}: ErrorListProps) {
  return (
    <Box sx={{ mt: 4, ...sx }}>
      {Object.entries(errors.fieldErrors).map(([key, errors], index) => (
        <Box key={index}>
          {errors.map((error, index) => (
            <Alert
              key={`${key}_${index}`}
              variant="outlined"
              severity="error"
              sx={{ mt: index === 0 ? 0 : 2 }}
            >
              {getErrorMessage(key, error, fieldLabels, showBackendErrors)}
            </Alert>
          ))}
        </Box>
      ))}
      {errors.nonFieldErrors.map(({ code, message }, index) => (
        <Alert
          key={`${code}_${index}`}
          variant="outlined"
          severity="error"
          sx={{ mt: index === 0 ? 0 : 2 }}
        >
          {message}
        </Alert>
      ))}
    </Box>
  );
}
